import { render, staticRenderFns } from "./newStock.vue?vue&type=template&id=52f3251e&"
import script from "./newStock.vue?vue&type=script&lang=js&"
export * from "./newStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports